import React, { useState } from "react";
import { Box } from "@mui/material";
import SubTitle from "../common/SubTitle";
import AlertList from "./AlertList";
import { PAGE_IDS, isJsonDrivenLayoutEnabled } from "../../config/uiLayoutConfig";
import { usePageLayout } from "../../context/LayoutContext";
import { getPageTitleKey } from "../../layout/alertsLayoutUtils";

export default function Alerts({ school = false } = {}) {
  const orgName = JSON.parse(localStorage.getItem("userState"))?.organization?.name;
  const [selectedTab, setSelectedTab] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const useJsonLayout = isJsonDrivenLayoutEnabled();
  const alertsPageId = school ? PAGE_IDS.SCHOOL_ALERTS : PAGE_IDS.FLEET_ALERTS;
  const { layout: moduleLayout } = usePageLayout(useJsonLayout ? alertsPageId : null);
  const pageTitle = getPageTitleKey(moduleLayout) || "Alerts";

  return (
    <>
      <SubTitle
        title={pageTitle}
        path={!school ? `${orgName || "organization"} > Alerts` : undefined}
      />
      <Box sx={{ margin: { xs: "0px 20px", md: "0px 40px" } }}>
        <AlertList
          moduleLayout={moduleLayout}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
      </Box>
      {!school && <Box sx={{ height: "8vh" }} />}
    </>
  );
}
